import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import {
  BestPriceByMonthRequest,
  BestPriceByMonthResponse,
  GetPriceTermRequest,
  GetPriceTermResponse,
} from '../../models/api/flight';
import { SERVICE_ENDPOINT } from '../../constants';

@Injectable({
  providedIn: 'root',
})
export class FlightHttpService {
  private _http = inject(HttpClient);

  getPriceTerm(request: GetPriceTermRequest) {
    return this._http.get<GetPriceTermResponse>(
      `${SERVICE_ENDPOINT.getPriceTerm}?airline=${request.airline}&groupClass=${request.groupClass}&fareClass=${request.fareClass}&AgCode=${request.agCode}`,
    );
  }

  bestPriceInMonth(request: BestPriceByMonthRequest) {
    return this._http.post<BestPriceByMonthResponse>(
      SERVICE_ENDPOINT.bestPriceInMonth,
      request,
    );
  }
}
